/* eslint-disable no-unused-vars */
import React from 'react';
import Navbar from '../GetStarted/Navbar';
import NavbarLower from '../GetStarted/NavbarLower';
import Grid from '@mui/material/Grid';
import Footer from './Footer';
import { useStyles,Item } from './SelfService';
import { Typography } from '@material-ui/core';
import {Card,CardContent, CardHeader} from "@material-ui/core";
import '../../App.css';
import { Alert } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, InputGroup, Row,Container,Col} from 'react-bootstrap';
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import MainMenu from '../GetStarted/MainMenu';
import {PrivacyInformation } from '../../utils/index'
import { fontSize } from '@mui/system';


export const PrivacyPolicyContent=()=>{
  const classes =  useStyles();

  return(

    <Grid container style={{ padding:10 }}>
        <div>
    <Typography
      color="textPrimary"
      variant="h5"
      className={classes.formTitle}
      flexGrow={2}
    >
    Privacy Statement of PostBank Uganda Limited<span className={classes.value}></span>
    </Typography>
    {
      PrivacyInformation.map((info) => (
        <Grid item xs={12} md={12} key={info.id}>
        <Alert variant="filled"style={{backgroundColor: "#ffffff", color: "#039BE5", fontSize:16}}><b>{info.subject}</b></Alert>
          <Card>
            <CardContent>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px'}}>{info.body.one}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.two}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.three}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.four}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.five}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.six}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.seven}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.eight}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.nine}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.ten}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.eleven}</Typography>
            </CardContent>
          </Card>
        <br/>
        </Grid>

    ))} 
    </div>
    </Grid>

  )
}

const PrivacyPolicy = () => {
    //Creating a responsive page layout
    return (
      <div>
          <NavbarLower/>
          <PrivacyPolicyContent/>
          <Footer/>
      </div>
  
    );
};


    
export default PrivacyPolicy;